import React, { Component } from 'react';
import './Error.scss';

const Error = ({ errorText }) => {
    return (
        <div className='error'>{errorText}</div>
    );
};

export default Error;



// WEBPACK FOOTER //
// ./application/components/Error/Error.jsx